// import Webview from '../native/visible/Webview'
import H5Container from '../../component/visible/Container'
import SingleOfferTemplate from "./SingleOfferTemplate"
import Video from '../visible/Video'

/**
 * Debug
 * 在启动本地服务调试时，需要将所有带*号的行注释掉，同时解注释带#号的行
 * 提交代码前务必恢复原样
 */
class H5VideoTemplate extends SingleOfferTemplate{
    constructor(props = {}) {
        super(props)
    }

    initComponents() {
        if(!this.container){
            // this.container = new Webview()
            this.container = new H5Container()
        }
        console.log('init player; ', this.campaign, this.unit, this)
        // H5 Video组件初始化 - START
        const cssText = {
            'object-fit': 'contain',
            width: '100vw',
            height: '100vh'
        }
        this.playerView = new Video({
            mute: true,
            src: this.campaign.video_url, // *
            // src: 'https://assets.dspunion.com/cdn-adn/vh/19/02/21/11/21/948e27b8d8571d92db0459076774e49e.mp4', // #
            autoplay: false,
            cssText: cssText,
            // controls: true,
        })
        // H5 Video组件初始化 - END
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.playerView && this.playerView.destory()
    }

    /**
     * 拉取video文件到本地
     */
    getVideoFile() {
        const resParam = {
            type: 1,
            url: this.campaign.video_url
        }
        return new Promise((resolve, reject) => {
            this.platform.getFilePathByRemoteUrlForRvIv(resParam)
            .then((ret) => {
                console.log('set video url', ret)
                this.playerView.setSrc(ret.path)
                this.playerView.setPoster()
                resolve()
            })
            .catch(error => {
                console.log(error)
                reject(error)
            })
        })
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish(){
        return Promise.all([
            super._isLoadFinish(),
            this.getVideoFile(), // *
        ])
    }
}

export default H5VideoTemplate